export default "__VITE_ASSET__BQqnyH9l__"